var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mounted
    ? _c(
        "portal",
        { attrs: { to: _vm.portalTo, disabled: !_vm.isMobile } },
        [_vm._t("default")],
        2
      )
    : _c("div", { staticStyle: { opacity: "0" } }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }